import { OnInit, Component, Input } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/shared/global.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ParametrosUACModel } from 'src/app/models/parametrosUAC.model';
import { Subscription } from 'rxjs';
import { TramiteUACModel } from 'src/app/models/tramiteUAC.model';
import { VentanillaUACModel, VentanillaUacPK } from 'src/app/models/ventanillaUAC.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { MotivosUacModel } from 'src/app/models/motivos.model';
import { SedesTramitesUAC, SedesTramitesUACPK } from 'src/app/models/sedesTramitesUAC.model';

@Component({
    selector: 'app-parametros-generales',
    templateUrl: './parametros-generales-UAC.component.html',
    styleUrls: ['./parametros-generales-UAC.component.scss']

})

export class ParametrosGeneralesUACComponent implements OnInit {

    public modalOptionsGuardarVentanilla: any;

    public listaParametros: any;
    private subscription: Subscription[];
    public filtroParametro: string;
    public tramites: TramiteUACModel[];
    public motivos: MotivosUacModel[];
    public turnos: TurnoUACModel[];
    public ventanillas: VentanillaUACModel[];
    public parametrosUAC: ParametrosUACModel[];
    public parametrosUACFiltro: ParametrosUACModel[];

    public paginas: number[];
    public inicio: number;
    public fin: number;
    public pantallaCrearParametro: boolean;
    public pantallaEditarParametro: boolean;
    public titulo: string;
    public subtitulo: string;

    public modulo: string;
    public estadoParametro: string;
    public nombreParametro: string;
    public descripcionParametro: string;
    public valorParametro: string;
    public tramiteAsociado: TramiteUACModel;
    public tiposParametros: string[];
    public tipoParametroSeleccionado: string;
    public idParametro: string;
    public fechaCreacion: Date;
    public fechaModificacion: Date;
    public sedeVentanilla: string;
    public idUsuarioActual: string;
    public nombreUsuarioActual: string;
    public letraTramite: string;
    public diasTramite: number;

    public sedes: any[] = [];
    public sedesTramites: any[] = [];
    public sedesTramitesDefault: any[] = [];
    public sedesTramitesList: any[] = [];
    public sedesTramitesEdicion: any[] = [];
    public modulos: any[] = [];
    public p: number;
    public sedeDefault: any;
    public sedeOriginal;


    constructor(

        private alertService: AlertService,
        private spinner: NgxSpinnerService,
        private global: GlobalService,
        private modalService: NgbModal,
        private urlService: UrlService,
        private utilService: UtilService

    ) {

    }

    ngOnInit() {
        this.estadoParametro = 'ACT';
        this.parametrosUAC = [];
        this.parametrosUACFiltro = [];
        this.obtenerDominio('Sede', 'sedes');
        this.obtenerDominio('Modulo', 'modulos');
        this.consultarTramites();
        this.consultarMotivos();
        this.consultarVentanillas();
        this.modalOptionsGuardarVentanilla = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MSG_CONFIRMACION_GUARDAR_PARAMETRO,
            'SI', 'NO', 'fas fa-save', true, false,
            'Guardar',
            null, 'btn-secondary');
        this.validarFormulario();

        this.tiposParametros = [];
        this.tiposParametros.push(ConstantesService.TRAMITE_UAC);
        this.tiposParametros.push(ConstantesService.VENTANILLA_UAC);
        this.tiposParametros.push(ConstantesService.MOTIVO_CONSULTA);
        this.idUsuarioActual = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
        this.idUsuarioActual = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
        this.nombreUsuarioActual = sessionStorage.getItem(ConstantesService.NOMBRE_SESSION);

        for (const modulo of this.modulos) {

            if (modulo.detalleDominioPK.nombreDetalleDominio === 'UAC') {

                this.modulo = modulo.detalleDominioPK.nombreDetalleDominio;
            }
        }

        this.fechaCreacion = new Date();
        this.fechaModificacion = new Date();
        this.sedeOriginal = '';
    }



    /**
     *
     *
     */
    catchException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    /**
     * @author klagos@asesoftware.com
     * Método que tranforma el filtro y organiza los parametros
     */
    buscarPorFiltro() {
        if (this.filtroParametro !== undefined && this.filtroParametro !== '') {
            this.parametrosUACFiltro = this.parametrosUAC.filter(
                elemento => this.eliminarTildes(elemento.idParametro.toUpperCase()).toString().indexOf
                    (this.filtroParametro.toUpperCase()) !== -1);
            this.p = 1;
            if (this.parametrosUACFiltro.length === 0) {
                this.alertService.generateAlertError('El parámetro consultado no se encuentra en el sistema', '');
            }

        } else {

            this.parametrosUACFiltro = this.parametrosUAC;
        }

        this.ordenarParametros();
    }

    /**
     * @author klagos@asesoftware.com
     * Método que reestablece el listado al borrar el filtro
     */
    validarFiltro() {
        if (this.filtroParametro === '') {
            this.parametrosUACFiltro = this.parametrosUAC;
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que elimina las tildes
     */
    eliminarTildes(cadena: string) {
        return cadena.replace('Á', 'A').replace('É', 'E').replace('Í', 'I').replace('Ó', 'O')
            .replace('Ú', 'U');
    }

    /**
     * @author klagos@asesoftware.com
     * Método que llama al servicio para realizar la consulta de tramites
     */
    consultarTramites() {
        this.spinner.show();
        const serviceProvider = 'consultarTramites';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.tramites = data;
                this.transformarTramites();
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible Cargar los Trámites');
            }
        );
    }

    /**
  * 
  * Método que llama al servicio para realizar la consulta de motivos de consulta
  */
    consultarMotivos() {
        this.spinner.show();
        const serviceProvider = 'consultarMotivos';
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.motivos = data;
                this.transformarMotivos();
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible Cargar los Motivos de consulta');
            }
        );
    }


    castearSedesMultiples() {
        this.sedesTramitesList = [];
        for (let sedes of this['sedes']) {
            let obj = { id: sedes.detalleDominioPK.nombreDetalleDominio, nombreElelemento: sedes.valor, checked: false };
            this.sedesTramitesList.push(obj);
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que llama al servicio para realizar la consulta de ventanillas
     */
    consultarVentanillas() {
        this.spinner.show();
        const serviceProvider = 'consultarVentanillas';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this.ventanillas = data;
                this.transformarVentanillas();
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible Cargar las Ventanillas');
            }
        );
    }


    getsedesTramites(evento: any) {
        this.sedesTramites = evento.elementosSeleccionados;
        this.sedesTramitesDefault = evento.elementosSeleccionados.filter(x => x.checked == true);
        this.validarFormulario();
    }

    /*
      * @author klagos@asesoftware.com
      */
    transformarMotivos() {

        for (const motivoConsulta of this.motivos) {

            const parametro: ParametrosUACModel = new ParametrosUACModel();
            parametro.modulo = 'UAC';
            parametro.tipoParametro = ConstantesService.MOTIVO_CONSULTA;
            parametro.idParametro = motivoConsulta.id;
            parametro.descripcion = motivoConsulta.descripcion;
            parametro.valor = motivoConsulta.motivoConsulta;
            parametro.estado = motivoConsulta.estado;
            parametro.fechaCreacion = motivoConsulta.fechaCreacion;
            parametro.fechaModificacion = motivoConsulta.fechaModificacion;
            parametro.modificadoPor = motivoConsulta.usuarioModificacion;

            this.parametrosUAC.push(parametro);
            this.parametrosUACFiltro.push(parametro);
        }
        this.ordenarParametros();
    }

    /*
    * @author klagos@asesoftware.com
    */
    transformarTramites() {
        for (const tramite of this.tramites) {
            const parametro: ParametrosUACModel = new ParametrosUACModel();
            parametro.modulo = 'UAC';
            parametro.tipoParametro = 'Servicio';
            parametro.idParametro = tramite.idTramite;
            parametro.descripcion = tramite.descripcion;
            parametro.valor = tramite.nombre;
            parametro.letra = tramite.letraTurno;
            parametro.estado = tramite.estado;
            parametro.fechaCreacion = tramite.fechaCreacion;
            parametro.fechaModificacion = tramite.fechaModificacion;
            parametro.modificadoPor = tramite.usuarioModificacion;
            parametro.sedesTramites = tramite.sedesTramites;
            parametro.diasTramite = tramite.diasTramite;
            tramite.sedesTramites.forEach((sede, index) => {
                let nombreSede = this.sedesTramitesList.filter(x => x.id == sede.sedesTramitesUACPK.sede);
                if (nombreSede.length > 0)
                    parametro.sede =
                        `${parametro.sede == undefined ? '' : parametro.sede} ${nombreSede[0].nombreElelemento} ${index == tramite.sedesTramites.length - 1 ? '' : ','}`
            });
            this.parametrosUAC.push(parametro);
            this.parametrosUACFiltro.push(parametro);
        }
        this.ordenarParametros();
    }

    /*
    * @author klagos@asesoftware.com
    */
    transformarVentanillas() {

        for (const ventanilla of this.ventanillas) {

            const parametro: ParametrosUACModel = new ParametrosUACModel();

            parametro.modulo = 'UAC';
            parametro.tipoParametro = 'Ventanilla';
            parametro.idParametro = ventanilla.ventanillaUacPK.numeroVentanilla;
            parametro.descripcion = ventanilla.descripcion;
            parametro.valor = ventanilla.nombre;
            parametro.estado = ventanilla.estado;
            parametro.fechaCreacion = ventanilla.fechaCreacion;
            parametro.fechaModificacion = ventanilla.fechaModificacion;
            parametro.modificadoPor = ventanilla.usuarioModificacion;

            let nombreSede = this.sedesTramitesList.filter(x => x.id == ventanilla.ventanillaUacPK.sede);
            if (nombreSede.length > 0)
                parametro.sede = `${parametro.sede == undefined ? '' : parametro.sede} ${nombreSede[0].nombreElelemento}`

            this.parametrosUAC.push(parametro);
            this.parametrosUACFiltro.push(parametro);
        }
        this.ordenarParametros();
    }

    /**
     * @author klagos@asesoftware.com
     *
     */
    pantallaCrearParametros() {

        this.titulo = 'CREAR NUEVO PARÁMETRO';
        this.subtitulo = 'Registrar información nuevo parámetro';

        for (const modulo of this.modulos) {

            if (modulo.detalleDominioPK.nombreDetalleDominio === 'UAC') {

                this.modulo = modulo.detalleDominioPK.nombreDetalleDominio;
            }
        }

        this.pantallaCrearParametro = true;
        this.validarFormulario();
    }

    /**
     * @author klagos@asesoftware.com
     *
     */
    editarParametros(parametro) {
        this.titulo = 'EDITAR PARÁMETRO';
        this.subtitulo = 'Editar información del parámetro';

        this.pantallaEditarParametro = true;

        this.modulo = parametro.modulo;
        this.estadoParametro = parametro.estado;
        this.nombreParametro = parametro.idParametro;
        this.fechaCreacion = parametro.fechaCreacion;
        this.fechaModificacion = new Date();
        this.valorParametro = parametro.valor;
        this.idUsuarioActual = parametro.modificadoPor;
        this.descripcionParametro = parametro.descripcion;
        if (parametro.tipoParametro === 'Servicio') {
            this.tipoParametroSeleccionado = parametro.tipoParametro;
            this.letraTramite = parametro.letra;
            this.diasTramite = parseInt(parametro.diasTramite);
            for (let sedes of this.sedesTramitesList) {
                for (let sedeActiva of parametro.sedesTramites) {
                    if (sedes.id == sedeActiva.sedesTramitesUACPK.sede) {
                        sedes.checked = true;
                        if (sedeActiva.isDefault == '1')
                            this.sedeDefault = sedeActiva.sedesTramitesUACPK.sede;

                    }
                }
            }
            this.sedesTramitesEdicion = JSON.parse(JSON.stringify(parametro.sedesTramites));


        } else if (parametro.tipoParametro === 'Ventanilla') {
            this.tipoParametroSeleccionado = parametro.tipoParametro;
            this.sedeVentanilla = parametro.sede;
            this.sedeOriginal = parametro.sede;
        } else if (parametro.tipoParametro === ConstantesService.MOTIVO_CONSULTA) {
            this.tipoParametroSeleccionado = parametro.tipoParametro;
        }

        this.validarFormulario();
    }

    volverPantalla() {

        this.pantallaCrearParametro = false;
        this.pantallaEditarParametro = false;

        this.modulo = '';
        this.tipoParametroSeleccionado = undefined;
        this.estadoParametro = 'ACT';
        this.nombreParametro = '';
        this.descripcionParametro = '';
        this.valorParametro = '';
        this.letraTramite = '';
        this.sedeVentanilla = undefined;
        this.sedesTramites = [];
        this.sedesTramitesEdicion = [];
        this.sedesTramitesList = [];
        this.sedeDefault = undefined;
        this.sedesTramitesDefault = [];
        this.tramites = null;
        this.diasTramite = null;
        this.ngOnInit();
        this.fechaCreacion = new Date();
        this.fechaModificacion = new Date();
        this.sedeOriginal = '';
    }

    /**
     * @author klagos@asesoftware.com
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    guardarParametros() {
        switch (this.tipoParametroSeleccionado) {
            case 'Servicio':
                const nuevoTramite: TramiteUACModel = new TramiteUACModel();
                nuevoTramite.estado = this.estadoParametro;
                nuevoTramite.nombre = this.valorParametro;
                nuevoTramite.descripcion = this.descripcionParametro;
                nuevoTramite.fechaCreacion = this.fechaCreacion;
                nuevoTramite.fechaModificacion = this.fechaModificacion;
                nuevoTramite.idTramite = this.nombreParametro;
                nuevoTramite.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
                nuevoTramite.maximoTurnos = '10';
                nuevoTramite.turnoActual = '0';
                nuevoTramite.letraTurno = this.letraTramite;
                nuevoTramite.sedesTramites = []
                nuevoTramite.diasTramite = this.diasTramite;
                this.sedesTramites.forEach(element => {
                    let nuevaSedeTramite: SedesTramitesUAC = new SedesTramitesUAC();
                    let nuevaSedeTramitePK: SedesTramitesUACPK = new SedesTramitesUACPK();
                    nuevaSedeTramitePK.idTramite = this.nombreParametro;
                    nuevaSedeTramitePK.sede = element.id;
                    nuevaSedeTramite.sedesTramitesUACPK = nuevaSedeTramitePK;
                    nuevaSedeTramite.isDefault = element.id == this.sedeDefault ? '1' : '0';
                    nuevaSedeTramite.isDelete = element.checked == 1 ? '0' : '1';
                    nuevaSedeTramite.fechaModificacion = this.fechaModificacion;
                    nuevaSedeTramite.fechaCreacion = this.fechaCreacion;
                    nuevaSedeTramite.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
                    if (this.pantallaCrearParametro && element.checked == true) {
                        nuevoTramite.sedesTramites.push(nuevaSedeTramite);
                    } else {
                        let nuevaSede = this.sedesTramitesEdicion.filter((x: SedesTramitesUAC) => x.sedesTramitesUACPK.sede == element.id)
                        if (nuevaSede.length > 0)
                            nuevoTramite.sedesTramites.push(nuevaSedeTramite);
                        else {
                            if (element.checked) {
                                nuevoTramite.sedesTramites.push(nuevaSedeTramite);
                            }
                        }
                    }
                })
                if (this.pantallaCrearParametro) {
                    ;
                    this.crearTramite(nuevoTramite);
                } else {
                    this.guardarTramite(nuevoTramite);
                }

                break;
            case 'Ventanilla':
                const nuevaVentanilla: VentanillaUACModel = new VentanillaUACModel();
                nuevaVentanilla.ventanillaUacPK = new VentanillaUacPK();

                nuevaVentanilla.estado = this.estadoParametro;
                nuevaVentanilla.ventanillaUacPK.numeroVentanilla = this.nombreParametro;
                nuevaVentanilla.nombre = this.valorParametro;
                nuevaVentanilla.descripcion = this.descripcionParametro;
                nuevaVentanilla.fechaCreacion = this.fechaCreacion;
                nuevaVentanilla.fechaModificacion = this.fechaModificacion;
                nuevaVentanilla.ventanillaUacPK.sede = this.sedeVentanilla;
                nuevaVentanilla.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);

                if (this.pantallaCrearParametro) {

                    this.crearVentanilla(nuevaVentanilla);

                } else {

                    this.guardarVentanilla(nuevaVentanilla);
                }
                break;
            case 'Motivo de consulta':
                const nuevoMotivo: MotivosUacModel = new MotivosUacModel();
                nuevoMotivo.id = this.nombreParametro;
                nuevoMotivo.estado = this.estadoParametro;
                nuevoMotivo.descripcion = this.descripcionParametro;
                nuevoMotivo.motivoConsulta = this.valorParametro;
                nuevoMotivo.fechaCreacion = this.fechaCreacion;
                nuevoMotivo.fechaModificacion = this.fechaModificacion;
                nuevoMotivo.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
                if (this.pantallaCrearParametro) {
                    this.crearMotivo(nuevoMotivo)
                } else {
                    this.guardarMotivo(nuevoMotivo)
                }
                break;

            default:
                console.log("Tramite no soportado")
                break;
        }

    }

	validarHabilitarBotonMotivo(){
		if(this.tipoParametroSeleccionado =='Motivo de consulta'){
			
			const nuevoMotivo: MotivosUacModel = new MotivosUacModel();
			nuevoMotivo.id = this.nombreParametro;
			nuevoMotivo.estado = this.estadoParametro;
			nuevoMotivo.descripcion = this.descripcionParametro;
			nuevoMotivo.motivoConsulta = this.valorParametro;
			nuevoMotivo.fechaCreacion = this.fechaCreacion;
			nuevoMotivo.fechaModificacion = this.fechaModificacion;
			nuevoMotivo.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
				
			let motivoIgual = false;
			if (this.pantallaCrearParametro) {				
				for (const motivo of this.motivos) {
					if (motivo.id == nuevoMotivo.id &&
						motivo.descripcion == nuevoMotivo.descripcion &&
						motivo.motivoConsulta == nuevoMotivo.motivoConsulta) {
						motivoIgual = true;
						if (motivo.estado == nuevoMotivo.estado) {
							return false;
						}
					}
				}
			} else {				
				for (const motivo of this.motivos) {
					if (motivo.id == nuevoMotivo.id &&
						motivo.descripcion == nuevoMotivo.descripcion &&
						motivo.motivoConsulta == nuevoMotivo.motivoConsulta && motivo.estado == nuevoMotivo.estado) {
						motivoIgual = true;
						return false;
					}
				}
			}
		}
		return true;
	}
	
	crearMotivo(nuevoMotivo: MotivosUacModel) {
        let motivoIgual = false;
        for (const motivo of this.motivos) {
            if (motivo.id == nuevoMotivo.id &&
                motivo.descripcion == nuevoMotivo.descripcion &&
                motivo.motivoConsulta == nuevoMotivo.motivoConsulta) {
                motivoIgual = true;
                if (motivo.estado == nuevoMotivo.estado) {
                    this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                        + ' encuentran registrados en el sistema', '');
                }

                this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                    + ' encuentran registrados en el sistema con un estado diferente', '');

            }
        }
        if (!motivoIgual) {
            this.spinner.show();
            const serviceProvider = 'crearMotivo';
            const motivoConsulta: MotivosUacModel = nuevoMotivo;
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            this.global.postGenerico(url, motivoConsulta).subscribe(
                data => {
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                    this.volverPantalla();
                    this.spinner.hide();
                }, err => {
                    this.catchException('No fue posible crear el motivo de consulta.');

                }
            );
        }
    }

    guardarMotivo(nuevoMotivo: MotivosUacModel) {
        let motivoIgual = false;
        for (const motivo of this.motivos) {
            if (motivo.id == nuevoMotivo.id &&
                motivo.descripcion == nuevoMotivo.descripcion &&
                motivo.motivoConsulta == nuevoMotivo.motivoConsulta && motivo.estado == nuevoMotivo.estado) {
                motivoIgual = true;
                this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                    + ' encuentran registrados en el sistema', '');
            }
        }
        if (!motivoIgual) {
            this.spinner.show();
            const serviceProvider = 'actualizarMotivo';
            const motivoConsulta: MotivosUacModel = nuevoMotivo;
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            this.global.putGenerico(url, motivoConsulta).subscribe(
                data => {
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                    this.volverPantalla();
                    this.spinner.hide();
                }, err => {
                    this.catchException('No fue posible crear el motivo de consulta.');

                }
            );
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    crearTramite(nuevoTramite: TramiteUACModel) {
        let tramiteIgual = false;
        nuevoTramite.nombre = nuevoTramite.nombre.trim();
        nuevoTramite.descripcion = nuevoTramite.descripcion.trim();
        nuevoTramite.idTramite = nuevoTramite.idTramite.trim();
        nuevoTramite.letraTurno = nuevoTramite.letraTurno.trim().toUpperCase();
        for (const tramiteConsultado of this.tramites) {

            if (tramiteConsultado.nombre === nuevoTramite.nombre &&
                tramiteConsultado.descripcion === nuevoTramite.descripcion &&
                tramiteConsultado.estado === nuevoTramite.estado &&
                tramiteConsultado.idTramite === nuevoTramite.idTramite &&
                tramiteConsultado.letraTurno === nuevoTramite.letraTurno) {

                tramiteIgual = true;
                this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                    + ' encuentran registrados en el sistema', '');

            } else if (tramiteConsultado.letraTurno === nuevoTramite.letraTurno) {

                tramiteIgual = true;
                this.alertService.generateAlertError('Ya existe un servicio con '
                    + ' la letra ingresada', '');

            } else if (tramiteConsultado.idTramite === nuevoTramite.idTramite) {

                tramiteIgual = true;
                this.alertService.generateAlertError('El id ingresado para el servicio ya se'
                    + ' encuentra registrado en el sistema', '');
            }

        }

        if (!tramiteIgual) {

            this.spinner.show();
            const serviceProvider = 'crearTramite';
            const tramite: TramiteUACModel = nuevoTramite;
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            this.global.postGenerico(url, tramite).subscribe(
                data => {
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                    this.volverPantalla();
                    this.spinner.hide();

                }, err => {

                    this.catchException('No fue posible crear el servicio.');

                }
            );
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    crearVentanilla(nuevaVentanilla: VentanillaUACModel) {

        let ventanillaIgual = false;

        nuevaVentanilla.descripcion = nuevaVentanilla.descripcion.trim();
        nuevaVentanilla.nombre = nuevaVentanilla.nombre.trim();
        nuevaVentanilla.ventanillaUacPK.numeroVentanilla =
            nuevaVentanilla.ventanillaUacPK.numeroVentanilla.trim().toUpperCase();

        this.consultarVentanillas();
        for (const ventanillaConsultada of this.ventanillas) {
            if (ventanillaConsultada.descripcion === nuevaVentanilla.descripcion &&
                ventanillaConsultada.estado === nuevaVentanilla.estado &&
                ventanillaConsultada.nombre === nuevaVentanilla.nombre &&
                ventanillaConsultada.ventanillaUacPK.numeroVentanilla === nuevaVentanilla.ventanillaUacPK.numeroVentanilla &&
                ventanillaConsultada.ventanillaUacPK.sede === nuevaVentanilla.ventanillaUacPK.sede) {

                ventanillaIgual = true;
                this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                    + ' encuentran registrados en el sistema', '');

            } else if (ventanillaConsultada.ventanillaUacPK.numeroVentanilla ===
                nuevaVentanilla.ventanillaUacPK.numeroVentanilla) {

                ventanillaIgual = true;
                this.alertService.generateAlertError('El id de la ventanilla ingresada para el parámetro ya se'
                    + ' encuentra registrado en el sistema', '');
            }
        }

        if (!ventanillaIgual) {

            this.spinner.show();
            const serviceProvider = 'crearVentanilla';
            const ventanilla: VentanillaUACModel = nuevaVentanilla;
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            this.global.postGenerico(url, ventanilla).subscribe(
                data => {
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                    this.volverPantalla();
                    this.spinner.hide();

                }, err => {

                    this.catchException('No fue posible crear la ventanilla.');

                }
            );
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    guardarTramite(tramite: TramiteUACModel) {
        let tramiteIgual = false;
        tramite.nombre = tramite.nombre.trim();
        tramite.descripcion = tramite.descripcion.trim();
        tramite.idTramite = tramite.idTramite.trim();
        tramite.letraTurno = tramite.letraTurno.trim().toUpperCase();

        // this.consultarTramites();
        let tramiteFiltrado = this.tramites.filter(x => x.idTramite == tramite.idTramite)
        let tramiteConsultado = tramiteFiltrado[0];
        if (tramiteConsultado.nombre === tramite.nombre &&
            tramiteConsultado.descripcion === tramite.descripcion &&
            tramiteConsultado.estado === tramite.estado &&
            tramiteConsultado.idTramite === tramite.idTramite &&
            tramiteConsultado.letraTurno === tramite.letraTurno &&
            JSON.stringify(tramiteConsultado.sedesTramites) === JSON.stringify(tramite.sedesTramites)
        ) {
            tramiteIgual = true;
            this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                + ' encuentran registrados en el sistema', '');

        }


        if (!tramiteIgual) {

            this.spinner.show();
            const serviceProvider = 'actualizarTramite';
            const nuevoTramite: TramiteUACModel = tramite;

            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            this.global.postGenerico(url, nuevoTramite).subscribe(
                data => {
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                    this.volverPantalla();
                    this.spinner.hide();

                }, err => {

                    this.catchException('No fue posible guardar el servicio.');

                }
            );
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    guardarVentanilla(ventanilla: VentanillaUACModel) {

        let ventanillaIgual = false;

        ventanilla.descripcion = ventanilla.descripcion.trim();
        ventanilla.nombre = ventanilla.nombre.trim();
        ventanilla.ventanillaUacPK.numeroVentanilla = ventanilla.ventanillaUacPK.numeroVentanilla.trim();

        this.consultarVentanillas();
        for (const vetanillaConsultada of this.ventanillas) {

            if (vetanillaConsultada.descripcion === ventanilla.descripcion &&
                vetanillaConsultada.estado === ventanilla.estado &&
                vetanillaConsultada.nombre === ventanilla.nombre &&
                vetanillaConsultada.ventanillaUacPK.numeroVentanilla === ventanilla.ventanillaUacPK.numeroVentanilla &&
                vetanillaConsultada.ventanillaUacPK.sede === ventanilla.ventanillaUacPK.sede) {

                ventanillaIgual = true;
                this.alertService.generateAlertError('Los valores ingresados para el parámetro ya se'
                    + ' encuentran registrados en el sistema', '');
            }
        }

        if (!ventanillaIgual) {

            this.spinner.show();
            const serviceProvider = 'actualizarVentanilla';
            const nuevaVentanilla: VentanillaUACModel = ventanilla;
            const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_UAC);
            this.global.postGenerico(url, nuevaVentanilla).subscribe(
                data => {
                    this.alertService.generateAlertSuccess('Se guardó información exitosamente', '');
                    this.volverPantalla();
                    this.spinner.hide();

                }, err => {

                    this.catchException('No fue posible guardar la ventanilla.');

                }
            );
        }

    }

    /**
     * @author klagos@asesoftware.com
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     */
    obtenerDominio(filtro, lista) {

        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlUAC(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_UAC);
        this.global.getGenerico(url).subscribe(
            data => {
                this[lista] = data;
                if (lista == 'sedes' && data.length > 0) {
                    this.castearSedesMultiples();
                }
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    validarFormulario() {

        const habilitado = this.utilService.validarCamposObligatorios(this.tipoParametroSeleccionado) &&
            this.utilService.validarCamposObligatorios(this.nombreParametro) &&
            this.utilService.validarCamposObligatorios(this.descripcionParametro) &&
            this.utilService.validarCamposObligatorios(this.valorParametro) &&
			this.validarHabilitarBotonMotivo();

        if (this.tipoParametroSeleccionado === 'Servicio') {
            let sedeDefault = this.sedesTramites.filter(x => x.id == this.sedeDefault && x.checked == true)
            let validarChecked = this.sedesTramites.filter(x => x.checked === true);
            this.modalOptionsGuardarVentanilla.disabled = !(habilitado &&
                this.utilService.validarCamposObligatorios(this.letraTramite) && validarChecked.length > 0
                && sedeDefault.length > 0);

        } else if (this.tipoParametroSeleccionado === 'Ventanilla') {

            this.modalOptionsGuardarVentanilla.disabled = !(habilitado &&
                this.utilService.validarCamposObligatorios(this.sedeVentanilla));

            if (this.sedeOriginal !== '' && this.sedeVentanilla !== this.sedeOriginal) {
                this.catchException('No se puede modificar la sede, por favor cree una Ventanilla nueva.');
                // TODO cbenavides, cambiar timeout para actualizar la opción de la sede
                setTimeout(() => {
                    this.sedeVentanilla = this.sedeOriginal;
                }, 30);
            }
        } else if (this.tipoParametroSeleccionado === 'Motivo de consulta') {
            this.modalOptionsGuardarVentanilla.disabled = !(habilitado);
        }
    }

    guardarParametro(evento: any[]) {
        if (evento[0]) {
            this.guardarParametros();
        }
    }

    ordenarParametros() {
        this.parametrosUACFiltro.sort((a, b) => {
            if (a.tipoParametro === b.tipoParametro) {
                return (a.idParametro < b.idParametro) ? -1 : (a.idParametro > b.idParametro) ? 1 : 0;
            } else {
                return (a.tipoParametro < b.tipoParametro) ? -1 : 1;
            }
        });
    }
}
